document.addEventListener("DOMContentLoaded", function () {
    const $svgElement = $(".divider svg");
    const svgElement = $svgElement.get(0);

    if (!svgElement) return; // Prevent errors if element doesn't exist

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            $svgElement.addClass("active");
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(svgElement);
  });